export default "__VITE_PUBLIC_ASSET__54e368b4__"